import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAward, FiUsers, FiClock, FiShield } = FiIcons;

const About = () => {
  const features = [
    {
      icon: FiAward,
      title: 'Award-Winning Quality',
      description: 'Recognized for excellence in craftsmanship and customer satisfaction.'
    },
    {
      icon: FiUsers,
      title: 'Expert Team',
      description: 'Skilled professionals with decades of combined experience.'
    },
    {
      icon: FiClock,
      title: 'On-Time Delivery',
      description: 'We respect your time and complete projects as scheduled.'
    },
    {
      icon: FiShield,
      title: 'Fully Licensed & Insured',
      description: 'Complete peace of mind with proper licensing and insurance.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                About LEWIS PROPERTY REMODELING
              </h2>
              <p className="text-xl text-gray-600 mb-6">
                With over 15 years of experience in the remodeling industry, LEWIS PROPERTY REMODELING L.L.C. has become a trusted name in home renovation. We take pride in delivering exceptional craftsmanship and turning your dream home into reality.
              </p>
              <p className="text-lg text-gray-600">
                Our commitment to quality, attention to detail, and customer satisfaction has earned us a reputation as one of the premier remodeling contractors in New York, New Jersey, and Pennsylvania. Every project is treated with the same level of care and professionalism, regardless of size.
              </p>
              <p className="text-lg text-gray-600 mt-4 font-semibold">
                General Contractor #PA141245
              </p>
            </div>
            {/* Stats */}
            <div className="grid grid-cols-2 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-2">500+</div>
                <div className="text-gray-600">Projects Completed</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-2">15+</div>
                <div className="text-gray-600">Years Experience</div>
              </div>
            </div>
          </motion.div>

          {/* Right Column - Image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <img
              src="https://images.unsplash.com/photo-1484154218962-a197022b5858?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
              alt="Modern home interior renovation"
              className="rounded-lg shadow-2xl"
            />
            <div className="absolute -bottom-6 -left-6 bg-blue-600 text-white p-6 rounded-lg shadow-lg">
              <div className="text-2xl font-bold">100%</div>
              <div className="text-sm">Satisfaction Rate</div>
            </div>
          </motion.div>
        </div>

        {/* Features Grid */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
        >
          {features.map((feature, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={feature.icon} className="w-8 h-8 text-blue-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600">
                {feature.description}
              </p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default About;